import React, { useEffect, useState } from "react";
import { Button, Card, Row, message } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FaRegKeyboard, FaXRay } from "react-icons/fa";
import { GrTechnology, GrUserNew } from "react-icons/gr";
import { HiUserGroup } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { setUserRole, userSignOut } from "../appRedux/actions";
import { createSessionIdAPI } from "../services/integrator-service";
import "./UserRoleSelection.css";
import { ReactComponent as AdminIcon } from "../assets/images/admin-icon.svg";
import { ReactComponent as ReceptionistIcon } from "../assets/images/receptionist-icon.svg";
import { ReactComponent as RadiologistIcon } from "../assets/images/radiologist-icon.svg";
import { ReactComponent as LogoutIcon } from "../assets/images/logout.svg";

const rolesObj = {
  ADMIN: "ADMIN",
  MRT: "MRT",
  MIS: "MIS",
  TYP: "TYP",
  GROUPADMIN: "GROUPADMIN",
  RECEPTIONIST: "RECEPTIONIST",
};

const UserRoleSelection = ({ authUser, updateUserRole, userSignOut }) => {
  const [selectedRole, setSelectedRole] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!authUser) {
      navigate("/signin");
    } else if (authUser.pacsId) {
      const generateSession = async () => {
        try {
          const response = await createSessionIdAPI(authUser.pacsId);
          if (response.success && response.data) {
            sessionStorage.setItem("pacsSessionId", response.data);
          } else {
            message.error("Failed to create pacs session Id.");
          }
        } catch (error) {
          message.error("An error occurred while creating session Id.");
        }
      };
      generateSession();
    }
  }, [authUser]);

  
  const getIcon = (role) => {
    let icon = <GrUserNew style={{ fontSize: "76px" }} />;
    switch (role) {
      case rolesObj.ADMIN:
        icon = <AdminIcon />;
        break;
      case rolesObj.RECEPTIONIST:
        icon = <ReceptionistIcon className="receptionist" />;
        break;
      case rolesObj.GROUPADMIN:
        role = (
          <HiUserGroup
            style={{
              fontSize: "76px",
              color:
                selectedRole && selectedRole === role
                  ? "#ffffff"
                  : "rgb(24,95,141)",
            }}
          />
        );
        break;
      case rolesObj.MRT:
        icon = (
          <GrTechnology
            style={{
              fontSize: "76px",
              color:
                selectedRole && selectedRole === role
                  ? "#ffffff"
                  : "rgb(24,95,141)",
            }}
          />
        );
        break;
      case rolesObj.MIS:
        icon = <RadiologistIcon />;
        break;
      case rolesObj.TYP:
        icon = (
          <FaRegKeyboard
            style={{
              fontSize: "76px",
              color:
                selectedRole && selectedRole === role
                  ? "#ffffff"
                  : "rgb(24,95,141)",
            }}
          />
        );
        break;
      default:
        break;
    }
    return icon;
  };

  return (
    <section className="auth-layout-container">
      <div className="gx-app-login-wrap">
        <div className="verify-container">
          <div
            style={{
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <h1 className="authenticator-heading">
              {`Hi, ${
                authUser ? authUser.firstName + " " + authUser.lastName : ""
              } Welcome to Clarity`}
            </h1>
            <h4 className="sub-heading">Please select a role to proceed</h4>
          </div>
          <Row gutter={16} type="flex" justify="center" style={{ gap: "15px" }}>
            {authUser &&
              authUser.roles.map((role) => {
                const icon = getIcon(role.name);
                return (
                  <Card
                    key={role.name}
                    onClick={() => {
                      if (["MIS", "MRT"].includes(role.name)) {
                        window.open(
                          `${process.env.REACT_APP_RADISCAN_REDIRECT_URL}?email=${authUser.email}&role=${role.name}`,
                          "_blank",
                          "noopener,noreferrer"
                        );
                      } else {
                        updateUserRole(role.name);
                      }
                    }}
                    className={`user-role-card ${
                      selectedRole === role.name ? "selected" : ""
                    }`}
                    hoverable
                  >
                    <div className="role-sub-container">
                      <div style={{ display: "flex", flexGrow: 1 }}>
                        <span style={{ margin: "auto" }}>{icon}</span>
                      </div>
                      <div>
                        <p className={"user-card-title"}>{role.name}</p>
                      </div>
                    </div>
                  </Card>
                );
              })}
          </Row>
          <div>
            {/* <Button
              disabled={!Boolean(selectedRole)}
              className="clarity-submit-button"
              type="primary"
              onClick={() => {
                if (!selectedRole) {
                  message.error("Please select a role");
                  return;
                }
                if (["MIS", "MRT"].includes(selectedRole)) {
                  window.open(
                    `${process.env.REACT_APP_RADISCAN_REDIRECT_URL}?email=${authUser.email}&role=${selectedRole}`,
                    "_blank",
                    "noopener,noreferrer"
                  );
                } else {
                  updateUserRole(selectedRole);
                }
              }}
            >
              {["MIS", "MRT"].includes(selectedRole)
                ? "Redirect to Clarity Radiscan"
                : "Continue to Dashboard"}
            </Button> */}
            <Button
              style={{ background: "transparent", border: "none" }}
              className={"clarity-submit-button"}
              onClick={userSignOut}
            >
              <span
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <LogoutIcon />
                <span>{"Log out"}</span>
              </span>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export const mapDispatchToProps = (dispatch) => ({
  userSignOut: bindActionCreators(userSignOut, dispatch),
  updateUserRole: bindActionCreators(setUserRole, dispatch),
});

const mapStateToProps = ({ auth }) => {
  return {
    authUser: auth ? auth.authUser : null,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserRoleSelection);
